/**
 * Inline SVGs for the FAQ section templates (from faqs.me's engine/icons.ts).
 * A section renders on the customer's own page, which may load no icon font,
 * so every glyph is inline, stroked in `currentColor` and sized by CSS.
 */

const stroked = (path) =>
    `<svg class="fq-ic" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${path}"/></svg>`;

/** The expand icon an accordion question carries, by `iconStyle`. */
export const ICONS = {
    chevron: stroked('M6 9l6 6 6-6'),
    plus: stroked('M12 5v14M5 12h14'),
    arrow: stroked('M5 12h14M13 6l6 6-6 6'),
    none: '',
};

/** How each expand icon turns while its question is open. */
export const ICON_OPEN_TRANSFORM = {
    chevron: 'rotate(180deg)',
    plus: 'rotate(45deg)',
    arrow: 'rotate(90deg)',
    none: 'none',
};

const misc = (inner) =>
    `<svg class="fq-svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;

export const MISC_SVG = {
    search: misc('<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>'),
    headset: misc('<path d="M3 14v-3a9 9 0 0 1 18 0v3"/><path d="M21 17a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 17a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>'),
    arrowLeft: misc('<path d="M19 12H5M11 18l-6-6 6-6"/>'),
    arrowRight: misc('<path d="M5 12h14M13 6l6 6-6 6"/>'),
    mail: misc('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>'),
};
